import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Button,
  Form,
  Icon,
  Row,
  Col,
  Checkbox,
  Typography,
  message,
} from 'antd';

import { Dialog } from '../../../components/UI';
import { Logo } from '../../Page';

import QueueAnim from 'rc-queue-anim';
import { Link } from 'react-router-dom';

import styles from './Signup.module.css';

const FormItem = Form.Item;
const { Title } = Typography;

message.config({
  top: 12,
  duration: 3
});

class Signup extends Component {
  state = {
    confirmDirty: false,
    agree: false,
    showTerms: false
  };

  callback = () => {
    if (this.props.error) {
      this.error(this.props.error);
    }

    if (this.props.payload.message) {
      this.success(this.props.payload.message);
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      const payload = {
        login: values.login,
        email: values.email,
        password: values.password
      };

      if (!err) {
        this.props.signup(payload, () => this.callback());
      }
    });
  };

  handleChange = () => {
    this.setState((state) => {
      return {
        agree: !state.agree
      };
    })
  };

  handleReadTerms = () => {
    this.setState({
      showTerms: true
    });
  };

  handleCancel = () => {
    this.setState({
      showTerms: false
    });
  };

  handleOk = () => {
    this.setState({
      showTerms: false
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  error = (msg) => {
    message.error(msg);
  };

  success = (msg) => {
    message.success(msg);
  };

  render() {
    const {
      protocol,
      hostname
    } = window.location;
    const logo = `${protocol}//${hostname}/logo/${hostname}/logo.png`;
    const { getFieldDecorator } = this.props.form;
    const {
      agree,
      showTerms
    } = this.state;
    const animationOptions = {
      delay: 400,
      duration: 300,
      animConfig: [
        { opacity: [1, 0], translateY: [0, -70] },
        { opacity: [1, 0], translateY: [0, 70] }
      ]
    };

    const modal = (
      <div>
        <h2>USE OF THIS WEBSITE IMPLIES ACCEPTANCE OF THE FOLLOWING TERMS AND CONDITIONS:</h2>
        <p>The Policy in question is not definitive, the Company reserves the right to add, remove, or modify any point of the Policy at any time without notifying you about this fact beforehand. Alterations become effective upon the posting of the modified Policy. Please, make sure that you check the website regularly for changes to the Policy. By viewing, visiting, surfing or exploring this website and/or using Company's services after the Policy alterations you agree to the changes. This Policy supersedes any other written, oral etc. agreement with the Company, but for cases when expressly agreed to the contrary in writing by the Company's authorized representative.</p>
        <h3>USE OF MATERIALS</h3>
        <p>All online materials without limitation including, any information, artwork, images, pictures, photos, texts, videos, audio, programs, and media files (the "Materials") contained on the Site are protected by copyright laws. You can get free access to the Materials and use them for personal non-commercial purposes only. Any alteration of the Materials or using them for any other purposes not mentioned above is strictly prohibited without Company's prior express written consent. Any reproduction, republishing, posting, transmission, or distribution of any Material on the Site is strictly prohibited but for cases mentioned above.</p>
        <h3>COPYRIGHT AND TRADEMARK</h3>
        <p>You are prohibited to use any Company's trademark, service mark, or copyrighted material from the Site without Company's express written consent. Copyright include all Company's parent companies and subsidiaries, without limitation, and/or its licensors. All rights reserved. Warning: all trademarks and logos at our Site and all materials and information are the property of their respective owners. Free use of such trademarks and logos is strictly prohibited without the prior consent of the rightful owners.</p>
        <h3>PRINTING OF MATERIALS</h3>
        <p>Notwithstanding the rules mentioned above, the Company authorizes the printing of the Site Materials for personal or educational purposes only. Attention! Any and all copyright notices originally included with the Materials must be included in any and all copies you print.</p>
        <h3>LINKS AND THIRD PARTY CONTENT</h3>
        <p>The Company tends to cooperate with a number of third parties; that is why we provide links to other websites or resources from the Site. The Company grants for third parties an opportunity to submit, post, transmit or make public any information, data, text, photographs, sound, graphics, video, messages, reviews or other materials ("Third Party Content") though the Site. Nevertheless, the Company has no control over this content or any other activities of third party websites/resources. The Company makes no guarantees about the accuracy, integrity, content, availability or quality of the information or services offered by such websites/resources or Third Party Content, and the Company takes no responsibility for unintended, objectionable, inaccurate, misleading or unlawful content that you may access. The Company is not liable in any way for any Third Party Content or services offered by any third party links available on the Site. The Company supplies you with these links for your convenience and choice. Any links available on the Site does not imply affiliation, endorsement or adoption of any information, content or service offered therein. When you leave the Site, you realize that other resources are not governed by the Company's Policy. Do not fail to review the applicable terms and policies of these sites, including privacy and data collection practices.</p>
        <h3>TRAFFIC QUALITY REPORTING</h3>
        <p>The Company shall track traffic quality on all traffic originating from the Publisher's site(s) or network of sites through a proprietary back-end system and shall provide the Publisher with its findings on a periodic basis. All data shall be confidential and shall not be disclosed to any third party by either party unless both parties agree in writing.</p>
        <h3>BLOCKING OF TRAFFIC FOR POOR PERFORMANCE</h3>
        <p>If the Company determines that traffic sources demonstrate poor performance, it will add these sources to a real-time block list. All sources of traffic placed on this list will be retested from time to time in order to determine whether or not the performance of the traffic source has improved. If after retesting by the Company, the performance of the source has not improved, the source will be permanently blocked by the Company. The determination of whether or not a traffic source must be blocked shall be made solely and exclusively by the Company. The Company reserves the right to terminate this agreement, with a 24 hour notice, if it determines that it is blocking a substantial amount of traffic and the relationship is no longer deemed beneficial.</p>
        <h3>CUSTOMER RESPONSIBILITY</h3>
        <p>When you surf or enter the Site you are expected to use it responsibly. The Company reserves the right to restrict, suspend and/or cancel access to any User who applies the Site in an appropriate a way that negatively affects other Company Users. The Company does not interfere with its Users and monitors its service electronically for a purpose of confirming that its facilities are intact, as a general practice. Electronic monitoring shows if all users are in compliance with the Policy and in case the Company detects any violation of the Policy or other user agreements, we take any measures to stop or correct this violation, including (but not limited to) denying access to our Site. Please, note that the Company reserves the right to take action against you or any customer of yours because of any unauthorized activities.</p>
        <h3>PROHIBITIONS</h3>
        <p>a) Use of the Site <br />You commit yourself not to use the Site for any illegal or unauthorized activities. You commit yourself not use any device, software, or technology to disrupt or attempt to interfere with the proper functioning of the Site. You commit yourself not to crawl, spider, scrape, or otherwise compromise automated agents and/or other technology to collect, harvest, mine, or otherwise interfere with this site.</p>
        <p>You will not: display, use, reproduce, cache, store, distribute, make derivative works of, modify, sell, resell, rent, license, sublicense, transfer, assign or redistribute the Technology and the Advertising Listings; alter, modify, add to, edit or delete the Advertising Listings; and display any Advertising Listings: (a) on any adult-oriented websites without the prior written approval of the Company; (b) on any obscene or illegal websites, or any website that violates any applicable laws or regulations or the rights of any third party; or (c) via any form of adware, spyware or method that violates applicable laws.</p>
        <p>b) Compliance with Intellectual Property Laws <br />When you are granted access to the Site, you commit yourself to obey the law and respect the intellectual property rights of other individuals. The use of any data of the Site is at all times subject to laws dealing with copyright ownership and use of intellectual property. You commit yourself to abide by laws regarding copyright ownership and use of intellectual property.</p>
        <h3>COMPANY'S ACTIONS</h3>
        <p>When a violation of the Policy occurs, the Company is the sole arbiter as to its severity. The Company reserves the right to refuse access to anyone at any time and to delete any Third Party Content without prior notice. When the Company becomes aware of the fact of Policy violation, we initiate an investigation during which your access to the Site may be restricted in order to prevent further attempts of unauthorized activities. The Company, at its sole discretion, can restrict, suspend, or terminate your access to the Site and/or even pursue civil remedies if violation is very severe. If a violation turns out to be a criminal offense, the Company is bound to notify appropriate law enforcement authorities without delay. Any unlisted activity is considered to be a violation of the Policy especially if it is illegal, irresponsible, or surmises disruptive use of the Internet. If you are guilty of Policy violation, you are responsible, without limitations, for any expenses (such as the cost of labor) to correct any damage done to the Site and business operations supported by the Site. You are to respond to all complaints incurred by the Company.</p>
        <h3>PAYMENT</h3>
        <p>A. Payment and Terms <br />The Company will pay Publisher amounts due in accord with the Company's numbers and will be due in full 45 days after the end of the month in which the traffic was served. Publisher will have access to log in and see numbers based on their traffic.</p>
        <p>B. Rate <br />The rate paid for each click will be passed and determined in the XML data stream. An accounting of any payments due Publisher will be maintained by both Parties. If a billing discrepancy of more than ten percent (10%) occurs, the Parties agree to work together diligently and in good faith to resolve such discrepancies. However, if a discrepancy cannot be corrected and/or resolved upon terms agreeable by both Parties, either party may terminate this agreement after giving the other party a seventy-two (72) hour notice of its intent to terminate in writing.</p>
        <p>&ETH;&iexcl;. Billing information / payment details <br />The Company pays to the billing information/payment details that publishers have indicated in their profiles. <br />Payment is made only in the absence of violations of the terms. The Company is not responsible for incorrect billing information/payment details located in the publishers profile, and is not responsible for payments to incorrectly listed billing information.</p>
        <h3>DISCLAIMER</h3>
        <p>Please, note that all services, information, and content data (collectively the "Information") accessible on the Site are supplied "as they are", without warranties of any kind (including, but not limited to, warranties of merchantability, fitness for a particular purpose, non-infringement) concerning the quality, sequence, accuracy, timeliness, reliability, or validity of the Information. The Company expressly disclaims any representation or warranty that our Site will contain no errors, will be secure or uninterrupted. Any oral advice or written information given by the Company (i.e. its workers, licensors etc.) will not create a warranty; you cannot rely on information or advice of that kind. The Company, its partners and suppliers bear no responsibility for any costs or damage resulting (either directly or indirectly) from any service or transaction you choose.</p>
        <p>YOU REALIZE, ACKNOWLEDGE, AND CONSENT THAT YOU USE COMPANY'S SERVICES AND ALL ASPECTS OF THE SITE AT YOUR OWN WILL AND RISK. THE COMPANY EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES REGARDING THE FACT THAT THE SITE OR THE SERVER SUPPORTING IT ARE FREE OF VIRUSES OR OTHER HARMFUL SOFTWARE. ADDDIRECTIVE HAS NO RESPONSIBILITY FOR DAMAGE TO YOUR PC, HARDWARE, DATA, INFORMATION, MATERIALS, AND BUSINESS THAT ARISES FROM YOUR USAGE OF THE SITE AND/OR THE INFORMATION, OR THE LACK OF INFORMATION, AVAILABLE ON THE SITE. FURTHERMORE, THE COMPANY TAKES NO RESPONSILITY FOR:</p>
        <ul>
          <li>ANY AND ALL DAMAGES OR LOSSES CAUSED (WHOLLY OR PARTIALLY) BY ACTIONS, OMISSIONS, OR NEGLIGENCE OF THE COMPANY;</li>
          <li>ANY AND ALL CIRCUMSTANCES THAT ARE BEYOND THE CONTROL OF THE COMPANY IN FINDING, COMPILING, OR DELIVERING THE INFORMATION;</li>
          <li>ANY AND ALL ERRORS, OMISSIONS, OR INACCURACIES IN THE DATA IRRESPECTIVE OF THE FACT HOW CAUSED, OR DELAYS/INTERRUPTIONS IN DATA DELIVERY;</li>
          <li>ANY DECISION MADE, OR ACTION TAKEN/NOT TAKEN BECAUSE OF RELIANCE UPON THE DATA AVAILABLE ON THE WEB SITE.</li>
          <li>WITHIN THIS SECTION THE TERM "COMPANY" INCLUDES, WITHOUT LIMITATION, ALL THE COMPANY'S DIVISIONS, SUBSIDIARIES, SUCCESSORS, PARENT COMPANIES, AND THEIR EXECUTIVES (INCLUDING NETNATION'S ONES), DIRECTORS, OFFICE WORKERS, MANAGERS, EMPLOYEES, CONSULTANTS, CONTRACTORS, AGENTS, AFFILIATES, THIRD-PARTY PROVIDERS, MERCHANTS, LICENSORS OR THE LIKE.</li>
        </ul>
        <h3>THIRD PARTY PROVIDERS AND PRODUCTS NOT BELOGNING TO THE COMPANY</h3>
        <p>Cooperating with the Company you agree that more services may be supported by third party providers of the Company. You agree that usage of such services is subject to corresponding agreements, policies, terms, and conditions in addition to points contained or referred to in current Agreement. If the Company (e.g. its employees, executives, directors, officers, managers, consultants, agents, parent companies, subsidiaries, or any third party entity related to the Company) mention products not belonging to the Company, this fact does not constitute any endorsement or recommendation by the Company. We disclaim any and all liabilities for warranty made by the vendors of any products or services not belonging to the Company.</p>
        <h3>LIMITATION OF LIABILITY</h3>
        <p>THE COMPANY (INCLUDING, WITHOUT LIMITATION, COMPANY'S EXECUTIVES, DIRECTORS, OFFICE WORKERS, ATTORNEYS, MANAGERS, EMPLOYEES, CONSULTANTS, CONTRACTORS, AGENTS, PARENT COMPANIES, SUBSIDIARIES, AFFILIATES, THIRD-PARTY PROVIDERS, MERCHANTS, LICENSORS, OR THE LIKE) OR ANYONE ELSE PARTICIPATING IN CREATING, PRODUCING, OR DISTRIBUTING COMPANY'S PRODUCTS AND SERVICES AND/OR THE SITE, IS BY APPLICABLE LAW IN NO EVENT AND UNDER NO THEORY OF LAW OR EQUITY RESPONSIBLE FOR ANY BUSINESS OR PERSONAL DAMAGES, PROFIT DECREASE, LOSS INCREASE ETC. OR FOR ANY CONSEQUENTIAL, SPECIAL, INCIDENTAL, PUNITIVE OR INDIRECT DAMAGES OR LOSSES OF ANY KIND RESULTING FROM ANY USE/INABILITY TO USE OR ACCESS THE SITE OF THE COMPANY EVEN IF WE WERE AWARE OF THE POSSIBILITY OF SUCH DAMAGES. YOUR PROPER WAY TO ACT IS TO DISCONTINUE USAGE OF THE SITE.</p>
        <h3>PRIVACY</h3>
        <p>The Company is highly concerned with your privacy during on-line communications and using our website. The Internet is just as risky as any other modern way of communication (mail, facsimile, voice telephone service etc.) &acirc;y any information can be intercepted and misused. That is why the Company recommends you to bear in mind that all kinds of online communications are insecure and does not take any liability for the security of data you choose to transmit over the Company's facilities. Regarding information we gather in connection with your use of our site, these data are subject to our Privacy Statement. Bear in mind that we do not control privacy practices of other sites to which we link, that is why we not responsible for the privacy policies of those sites.</p>
        <h3>INDEMNITY</h3>
        <p>You commit yourself to protect, defend and hold harmless the Company any third party connected to it (including, without limitation, third party vendors, executives, directors, office workers, managers, employees, consultants, agents, parent companies, and subsidiaries) from any and all responsibilities, losses, expenses, judgments, damages, claims etc. including, without limitation, any and all legal fees that arise from using the Site. The Company is also not responsible for traffic sources; the webmaster providing the respective traffic takes this responsibility.</p>
        <h3>GENERAL INFORMATION</h3>
        <p>A. Jurisdiction and Sever ability <br />This Policy, just as any other Company agreement, is governed by the Law of the UK (no reference to its conflicts of laws principles is made). If any litigation or arbitration arises between a customer and the Company, it will be held in the UK; the customer agrees with personal jurisdiction and its venue. If any item or point the current Policy or any other Company's agreement is considered by a court of competent jurisdiction to be unenforceable for any reason, all other points of the Policy or the agreement are still in full force and effect.</p>
        <p>B. No Waiver <br />If any party fails to exercise any right or provision of the current Policy, this fact does not mean a waiver of the right or provision in question.</p>
        <p>C. Construction and Interpretation <br />This Policy can include the masculine, feminine, or neuter genders; each of them is considered to include all genders. When this Policy contains the singular is used, it is considered to include the plural and vice versa, according to the context. Separation of the Policy into sections/paragraphs, usage of headings/captions, are applied to make the text convenient for readers, but none of the above- mentioned affects the construction or interpretation of the Policy. Any ambiguity is to be resolved against the drafting party; furthermore this ambiguity is not be applicable in the construction or interpretation of the Policy.</p>
        <p>D. Agreement and Exclusivity <br />The Policy itself and/or any other specific Company agreement regarding its products and services, is designed to reach mutual understanding and agreement between yourself and the Company and direct your safe use of the Site. We inform you that if you decide to use affiliate services, Third Party Content or third-party software, you may be subject to additional terms and conditions. This Policy supersedes any other written agreement (including digitized/computerized one), oral agreement, and/or agreement by conduct but for cases when expressly agreed to the contrary in writing by the Company's authorized representative. This Policy, and/or any other specific Company agreement regarding its products and services concerns the Company and its customers only, it has no effect with any third party but for cases expressly pointed out by the Company.</p>
      </div>
    );

    return (
      <>
        <QueueAnim {...animationOptions}>
          <div key="step" className={styles['auth-page']}>
            <Logo
              src={logo}
              alt=""
            />
            <Title>Sign Up</Title>
            <Form
              className="form"
              onSubmit={this.handleSubmit}
            >
              <FormItem>
                {getFieldDecorator('login', {
                  rules: [{ required: true, message: 'Enter login' }],
                })(
                  <Input
                    prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Login"
                    size="large"
                    autoFocus
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('email', {
                  rules: [
                    { type: 'email', message: 'Enter valid e-mail' },
                    { required: true, message: 'Enter e-mail' },
                  ],
                })(
                  <Input
                    prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="E-mail"
                    size="large"
                  />,
                )}
              </FormItem>
              <FormItem hasFeedback>
                {getFieldDecorator('password', {
                  rules: [
                    { required: true, message: 'Enter password' },
                    { validator: this.validateToNextPassword },
                  ],
                })(
                  <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Password"
                    size="large"
                    type="password"
                  />,
                )}
              </FormItem>
              <FormItem hasFeedback>
                {getFieldDecorator('confirmPassword', {
                  rules: [
                    { required: true, message: 'Confirm password' },
                    { validator: this.compareToFirstPassword },
                  ],
                })(
                  <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Confirm password"
                    size="large"
                    type="password"
                  />,
                )}
              </FormItem>
              <FormItem>
                <Checkbox onChange={this.handleChange}>
                  I Agree with <Button
                    type="link"
                    onClick={this.handleReadTerms}
                    className={styles['btn-link-terms']}
                  >
                    Terms and Conditions
                  </Button>
                </Checkbox>
              </FormItem>
              <FormItem>
                <Row>
                  <Col xs={8}>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      disabled={!agree}
                    >
                      Sign Up
                    </Button>
                  </Col>
                  <Col
                    xs={16}
                    className={styles['btn-container']}
                  >
                    <Link to="/login">Login</Link>
                    <Link to="/reset">Forgot Password?</Link>
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </div>
        </QueueAnim>

        <Dialog
          title="Terms of use"
          visible={showTerms}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={1170}
          content={modal}
          hideCancel
        />
      </>
    );
  }
};

Signup.propTypes = {
  signup: PropTypes.func.isRequired,
  payload: PropTypes.shape({
    message: PropTypes.string,
    login: PropTypes.string
  }),
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

export default Signup = Form.create({})(Signup);
